export default "__VITE_ASSET__BnzbdCgm__"